module.exports = __webpack_public_path__ + "static/media/evenbreeze-3.95dbc71f.jpg";